<template>
  <a
    @click.prevent="handleClick"
    :disabled="(!enabledToClick && activatedDisabled) || null"
  >
    <span>無料</span>
    <div v-if="ableToDisplayAppealingText">
      <strong>{{ appealingText }}</strong
      >を紹介してもらう
      <i class="atlas-glyphs-page-right"></i>
    </div>
    <div v-else>
      <strong>希望にピッタリの求人を紹介してもらう</strong>
      <i class="atlas-glyphs-page-right"></i>
    </div>
  </a>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { useEmploymentTypeStore } from "@component_path/agent_selection_wish_module/custom_hook/EmploymentType";
import { usePositionTypeStore } from "@component_path/agent_selection_wish_module/custom_hook/PositionType";
import { usePrefectureIdStore } from "@component_path/inquiry_form_common_module/custom_hook/PrefectureId";

const store = useStore();

const emit = defineEmits(["click"]);

const props = defineProps({
  displayAppealingText: {
    type: Boolean,
    default: false
  },
  // ボタンの配置によってdisabled属性をつけてよいかpropsが決める
  activatedDisabled: {
    type: Boolean,
    default: false
  }
});

const { employmentTypeText } = useEmploymentTypeStore();
const { positionTypeText } = usePositionTypeStore();
const { prefectureText } = usePrefectureIdStore();

const appealingText = computed(
  () =>
    `${prefectureText.value}・${employmentTypeText.value}・${positionTypeText.value}の非公開求人`
);
const ableToDisplayAppealingText = computed(
  () => props.displayAppealingText && enabledToClick
);
const enabledToClick = computed(
  () =>
    (prefectureText.value !== "" &&
      employmentTypeText.value !== "" &&
      positionTypeText.value !== "") === true
);

const handleClick = () => {
  emit("click");
};
</script>
